import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

export const MetricsContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const MetricCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  gap: 1rem;

  p {
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
  }
`;

export const ParamsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #00616f;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;

  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Body = styled.div`
  display: flex;
  gap: 2rem;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const WorkflowSection = styled.div`
  flex: 1;
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #15c170;
    margin: 1.5rem 0;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  gap: 1rem;
  align-items: end;
  margin-bottom: 1rem;

  & > div:nth-child(-n + 2) {
    flex: 1;
  }
`;
